// The API requires a scheme-qualified URL ("Invalid URL" otherwise). People
// type bare hosts — "namshi.com" — so add https:// when no scheme is present.
const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i;

export function normaliseScanInput(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) return '';
  return HAS_SCHEME.test(trimmed) ? trimmed : `https://${trimmed}`;
}
